import classNames from 'classnames';
import { HTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type IModalContainerProps = HTMLAttributes<HTMLDivElement>;

export function ModalContainer({
  children,
  className,
  ...rest
}: PropsWithChildren<IModalContainerProps>) {
  return (
    <div
      className={classNames(
        twMerge(
          'bg-white flex flex-col relative scale-100 z-[110] transform will-change-transform animation-scale',
          className,
        ),
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
